import React, {useEffect} from 'react';

import {useSelector} from 'react-redux';

import bem from 'client/services/bem';
import {useFeatureAccess, useLanguage, useViewMode} from 'client/services/hooks';

import {selectAutotask} from 'client/ducks/autotask/selectors';
import {selectCurrentClient} from 'client/ducks/clients-list/selectors';

import ToggleInput from 'client/common/inputs/toggle-input';
import Dropdown from 'client/common/selects/dropdown';

import cssModule from './view-mode-settings-dropdown.module.scss';

const b = bem('view-mode-settings-dropdown', {cssModule});

const ViewModeSettingsDropdown: React.FC = () => {
  const lang = useLanguage('HEADER.VIEW_MODE_SETTINGS_DROPDOWN');
  const {viewMode, setViewModeSettings, toggleViewModeSetting} = useViewMode();

  const client = useSelector(selectCurrentClient);
  const autotask = useSelector(selectAutotask);

  const {operationPathFlow} = useFeatureAccess({client, autotask});

  useEffect(() => {
    setViewModeSettings({operationPathFlow: autotask?.editor_v2 ?? client?.editor_v2});
  }, [autotask?.editor_v2, client?.editor_v2, setViewModeSettings]);

  if (!viewMode.on) {
    return null;
  }

  const handleToggleChange = () => {
    toggleViewModeSetting('operationPathFlow');
    setViewModeSettings({operationPathFlow: !operationPathFlow});
  };

  return (
    <Dropdown
      position="bottom-end"
      iconName="gear-outline"
      triggerProps={{
        iconConfig: {width: 16, height: 16},
      }}
      options={[
        {
          label: (
            <ToggleInput
              className={b('toggle')}
              label={lang.EDITOR_V2}
              checked={operationPathFlow}
              labelPosition="right"
              rounded
            />
          ),
          onClick: handleToggleChange,
        },
      ]}
    />
  );
};

export default ViewModeSettingsDropdown;
